module.exports = __webpack_public_path__ + "static/media/gameoflife.97d56322.png";